import type { MagazineMediumTypes } from '$lib/services/tracking/googleAnalytics/events';
import type { SupportedLocale } from '@viamichelin/business';
import { magazineUrlByLocale } from '$lib/services/advertising/magazine';
import { track } from '$lib/services/tracking/googleAnalytics';

export const magazineMediumMap: Record<string, MagazineMediumTypes> = {
	browseButton: 'browse_button',
	launchpadRedirection: 'launchpad_redirection',
	autopromo: 'autopromo',
	learnMoreAccountBenefits: 'learn_more_account_benefits',
};

export function formatMagazineUrlWithTracking(medium: MagazineMediumTypes, locale: SupportedLocale = 'en-US') {
	const magUrlByDefinedLocale = new URL(magazineUrlByLocale[locale]);
	magUrlByDefinedLocale.searchParams.set('utm_source', 'viamichelin_web');
	magUrlByDefinedLocale.searchParams.set('utm_medium', medium);

	return magUrlByDefinedLocale.toString();
}

export function trackMagazineRedirection(medium: MagazineMediumTypes) {
	track({
		action: 'mag_redirection',
		payload: {
			action: 'click',
			context: medium,
		},
	});
}
